import { FC, ReactNode } from 'react'
import { Box, BoxProps } from '@mui/material'

export interface CardContainerProps {
  children: ReactNode
  boxProps?: BoxProps
}

export const CardContainer: FC<CardContainerProps> = ({ children, boxProps }) => {
  return (
    <Box
      padding="1rem"
      bgcolor="white"
      borderRadius="0.75rem"
      display="flex"
      flexDirection="column"
      width="100%"
      flex={1}
      {...boxProps}
    >
      {children}
    </Box>
  )
}
